import React, { useEffect } from 'react';
import { useStyles } from './Confirmation.styles';
import TextRender from 'components/Global/TextRender/TextRender';
import { pageLoad } from 'helpers/Analytics';
import { IPageLoadData } from 'interfaces/analytics';
import { ICta } from 'interfaces/cta';

export interface IConfirmation {
  title: string;
  description: string;
  confirmationPageLoadConfig?: IPageLoadData;
  ctas?: {
    [key: string]: ICta;
  };
}

export function Confirmation({
  title,
  description,
  ctas,
  confirmationPageLoadConfig,
}: IConfirmation): JSX.Element {
  const classes = useStyles();
  useEffect(() => {
    if (confirmationPageLoadConfig) {
      pageLoad(confirmationPageLoadConfig);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.root}>
      <h2 className={`${classes.title} acr-caption-3`} data-automation={title}>
        {title}
      </h2>

      <TextRender
        tagName="p"
        className={`${classes.description} acr-paragraph-8`}
        text={description}
      />

      {ctas && (
        <div className={classes.ctaContainer}>
          {Object.keys(ctas).map((key) => {
            return (
              <a
                key={key}
                className={'acr-paragraph-8'}
                href={ctas[key].url}
                target={ctas[key].target || undefined}
              >
                {ctas[key].label}
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
}
